// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { hourglass16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-hourglass': IconHourglass;
    }
}

/**
 * The icon component for the 'hourglass' icon
 */
export class IconHourglass extends Icon {
    public constructor() {
        super(hourglass16X16);
    }
}

registerIcon('icon-hourglass', IconHourglass);
export const iconHourglassTag = 'nimble-icon-hourglass';
